import { render, staticRenderFns } from "./VariantDialog.vue?vue&type=template&id=33bc52d6&scoped=true"
import script from "./VariantDialog.vue?vue&type=script&lang=js"
export * from "./VariantDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bc52d6",
  null
  
)

export default component.exports